export default "__VITE_ASSET__BtIhEq6T__"